import { apiRequest } from '../http'

/**
 * 根据hsk等级 获取折扣商品列表 data: {products:{price_id, item_count, unit_price, currency, currency_base, price, discount}}
 * @param {*} params { level_id: 1} 等级id
 */
export const getCodesDiscount = (params) =>
  apiRequest.get('/person/pay/level_product_list', { params })

/**
 * 获取已购买的兑换码 用以兑换试卷
 * @returns {data: {code: string, code_count: number}}
 */
export const getUseCodes = (params) => apiRequest.get('/v1/examination/code_recommend', { params })
/**
 * 获取兑换码列表
 * @returns {data: {code: string, code_count: number}}
 */
export const getCodesLists = (params) =>
  apiRequest.get('/v1/examination/code_recommend_list', { params })

/**
 * 根据订单id查询code生成结果
 * @param {*} param { order_id: xxx}
 * @returns {data: {level_type: 'HSK|YCT', level_num: 1|2|3|4|5|6, codes: xxxx}}
 */
export const getCodesByOrder = (params) => apiRequest.get('/person/pay/get_order_codes', { params })

/**
 * 获取折扣定价的 use code 列表
 * @returns
 */
export const getCodesPriceList = () => apiRequest.get('/person/pay/code_product_list')
//校验用户是否有购买权限
export const checkUserPromotion = (params) => apiRequest.get('/person/pay/check_promotion', { params })
